var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFmhRefresh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "System/Line/Refresh"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Refresh",
    d: "M12 20C9.76667 20 7.875 19.225 6.325 17.675C4.775 16.125 4 14.2333 4 12C4 9.76667 4.775 7.875 6.325 6.325C7.875 4.775 9.76667 4 12 4C13.15 4 14.25 4.23767 15.3 4.713C16.35 5.18767 17.25 5.86667 18 6.75V5C18 4.44772 18.4477 4 19 4C19.5523 4 20 4.44772 20 5V11L14 11C13.4477 11 13 10.5523 13 10C13 9.44772 13.4477 9 14 9L17.2 9C16.6667 8.06667 15.9377 7.33333 15.013 6.8C14.0877 6.26667 13.0833 6 12 6C10.3333 6 8.91667 6.58333 7.75 7.75C6.58333 8.91667 6 10.3333 6 12C6 13.6667 6.58333 15.0833 7.75 16.25C8.91667 17.4167 10.3333 18 12 18C13.2833 18 14.4417 17.6333 15.475 16.9C16.3034 16.3121 16.9337 15.5742 17.3657 14.6864C17.5605 14.2863 17.9483 14 18.3933 14C19.0788 14 19.5808 14.6528 19.3026 15.2794C18.7713 16.4758 17.9704 17.4911 16.9 18.325C15.4667 19.4417 13.8333 20 12 20Z",
    fill: "#045694"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmhRefresh);
export default __webpack_public_path__ + "static/media/fmh-refresh.35c85bacb673d431fb3e93dd2ec06f42.svg";
export { ForwardRef as ReactComponent };